import { ZoneId } from "./zones";

export type MonsterZone = "any" | ZoneId;

export interface MonsterTemplate {
  id: string;
  label: string;
  codex: string;
  hp: number;
  attack: number;
  killExp: number;
  goldMin: number;
  goldMax: number;
  requiredLevel: number;  // 미달이어도 사냥은 가능 — 경고만 표시
  zone: MonsterZone;       // "any"면 모든 존(Room)에 각각 count만큼 스폰
  count: number;
  victoryLine: string;     // 처치 시 로그 결과 줄에 사용
  battleLine?: string;     // 있으면 전투 중 랜덤 액션 문구 대신 사용
  color: number;
  shape: "circle" | "square";
  radius: number;
  canMultiply?: boolean;
  multiplyChance?: number; // 0~1
  zoneCap?: number;        // canMultiply일 때 존(Room)당 최대 마리 수
}

export const MONSTERS: MonsterTemplate[] = [
  {
    id: "slime",
    label: "NullPointerException 슬라임",
    codex: "존재하지 않는 것을 있다고 믿고 건드렸을 때 나타남. 초보 개발자의 천적.",
    hp: 30, attack: 5, killExp: 20, goldMin: 5, goldMax: 20,
    requiredLevel: 1, zone: "zone_gangnam", count: 5,
    victoryLine: "처치 성공!",
    color: 0x27c93f, shape: "circle", radius: 6,
  },
  {
    id: "cors_gatekeeper",
    label: "CORS 에러 문지기",
    codex: "다른 출처에서 온 요청을 막는 수문장. 헤더 설정으로만 통과 가능.",
    hp: 60, attack: 8, killExp: 35, goldMin: 15, goldMax: 30,
    requiredLevel: 3, zone: "zone_hongdae", count: 3,
    victoryLine: "Access-Control-Allow-Origin: * 를 외쳤다!",
    color: 0x3498db, shape: "square", radius: 7,
  },
  {
    id: "infinite_loop_golem",
    label: "무한루프 골렘",
    codex: "탈출 조건을 설정하지 않으면 영원히 같은 자리를 맴돈다. 서버 CPU를 잡아먹음.",
    hp: 90, attack: 12, killExp: 50, goldMin: 25, goldMax: 45,
    requiredLevel: 5, zone: "zone_hongdae", count: 2,
    victoryLine: "break문을 꽂아넣었다!",
    battleLine: "골렘이 같은 패턴을 반복한다... i++를 까먹었다",
    color: 0x7f8c8d, shape: "circle", radius: 9,
  },
  {
    id: "tech_debt_zombie",
    label: "기술 부채 좀비",
    codex: "처음엔 작았지만 방치하면 무리를 이룸. 이자처럼 늘어남.",
    hp: 120, attack: 15, killExp: 70, goldMin: 40, goldMax: 60,
    requiredLevel: 7, zone: "any", count: 1,
    victoryLine: "리팩토링 빗자루를 휘둘렀다!",
    color: 0x9b59b6, shape: "circle", radius: 8,
    canMultiply: true, multiplyChance: 0.2, zoneCap: 4,
  },
];

export function getMonsterTemplate(id: string): MonsterTemplate | undefined {
  return MONSTERS.find((m) => m.id === id);
}
